// Som de "prato pronto pra levar" na tela do Garçom.
//
// Arquivo escolhido pelo dono (23/09/2026): um jingle de sino rápido, em
// public/sounds/garcom_prato_pronto.mp3 (origem: salamisound "4x quick jingle
// bell"). É de propósito diferente da campainha sintetizada do "chamar
// garçom" do Mesa QR — o garçom distingue de ouvido "tem prato pra levar" de
// "a mesa me chamou".
//
// Toca UMA vez por prato que fica pronto, não repete. Num salão cheio, som
// repetindo vira barulho de fundo que todo mundo aprende a ignorar.
//
// Se o arquivo não tocar (bloqueio do navegador, arquivo fora do ar), cai no
// toque sintetizado de três notas, pra o aviso nunca sumir em silêncio.

const ARQUIVO = "/sounds/garcom_prato_pronto.mp3";

let contexto = null;
function contextoDeAudio() {
  if (contexto) return contexto;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    contexto = Ctx ? new Ctx() : null;
  } catch (_) {
    contexto = null;
  }
  return contexto;
}

function tocarSintetizado() {
  const ctx = contextoDeAudio();
  if (!ctx) return;
  try {
    if (ctx.state === "suspended") ctx.resume();
    [523, 659, 784].forEach((hz, i) => {
      const inicio = ctx.currentTime + i * 0.12;
      const osc = ctx.createOscillator();
      const ganho = ctx.createGain();
      osc.type = "triangle";
      osc.frequency.setValueAtTime(hz, inicio);
      ganho.gain.setValueAtTime(0.0001, inicio);
      ganho.gain.exponentialRampToValueAtTime(0.3, inicio + 0.02);
      ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + 0.45);
      osc.connect(ganho);
      ganho.connect(ctx.destination);
      osc.start(inicio);
      osc.stop(inicio + 0.5);
    });
  } catch (_) { /* sem áudio: a tela continua funcionando */ }
}

export function tocarPratoPronto() {
  if (!ARQUIVO) return tocarSintetizado();
  try {
    const audio = new Audio(ARQUIVO);
    audio.volume = 0.8;
    audio.play().catch(tocarSintetizado);
  } catch (_) {
    tocarSintetizado();
  }
  return undefined;
}
